var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTreeView = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 1.5H12V4.5H1.5L1.5 1.5ZM0 1.5C0 0.671573 0.671573 0 1.5 0H12C12.8284 0 13.5 0.671573 13.5 1.5V4.5C13.5 5.32843 12.8284 6 12 6H3.75V11.25H9V10.5C9 9.67157 9.67157 9 10.5 9H22.5C23.3284 9 24 9.67157 24 10.5V13.5C24 14.3284 23.3284 15 22.5 15H10.5C9.67157 15 9 14.3284 9 13.5V12.75H3.75V20.25H9V19.5C9 18.6716 9.67157 18 10.5 18H22.5C23.3284 18 24 18.6716 24 19.5V22.5C24 23.3284 23.3284 24 22.5 24H10.5C9.67157 24 9 23.3284 9 22.5V21.75H3C2.58579 21.75 2.25 21.4142 2.25 21V6H1.5C0.671573 6 0 5.32843 0 4.5V1.5ZM22.5 10.5H10.5V13.5H22.5V10.5ZM10.5 19.5H22.5V22.5H10.5V19.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTreeView);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tree-view.8b18f8e8d1fd954502564854b4e177c9.svg";